import CoreHttpError from './CoreHttpError';

export default class extends CoreHttpError {
}
